// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { GenericSaveResetButtons } from '@components/GenericSaveResetButtons';
import { Spacer } from '@presentational/spacing/Spacer';
import { Grid } from 'semantic-ui-react';
import { CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { useUpdateClusterLinkingWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { useParams } from 'react-router-dom';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { SPClusterLinkingWorkloadNameContainer } from '@streaming-projects/workloads/cluster-linking-workloads/workload-details/SPClusterLinkingWorkloadNameContainer';
import { CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG } from '@streaming-projects/workloads/cluster-linking-workloads/config';
import { ClusterLinkingWorkloadContext } from '@streaming-projects/workloads/cluster-linking-workloads/contexts/ClusterLinkingWorkloadContext';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { FORM_NAMES } from '@streaming-projects/enums';

export const SPClusterLinkingWorkloadDetailsContainer = () => {
  const { orgId, spId, clusterLinkingWorkloadId } = useParams();
  const { values, initialValues } = useFormikContext();
  const [updateWorkload] = useUpdateClusterLinkingWorkloadMutation();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  const workloadData = useContext(ClusterLinkingWorkloadContext);

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG,
    FORM_NAMES.CLUSTER_LINKING.WORKLOAD_DETAILS_FORM
  );

  return (
    <>
      <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
        <>
          <GenericSaveResetButtons
            fieldsConfig={CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG.filter(
              (x) =>
                x.backendFieldName === CLUSTER_LINKING_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME
            )}
            onSaveHandler={async (payload) => {
              return await updateWorkload({
                orgId,
                spId,
                clusterLinkingWorkloadId,
                payload: {
                  cluster_linking_resource_id: workloadData?.cluster_linking_resource_id,
                  sp_version: spStreamingProjectData?.sp?.version,
                  ...payload,
                },
              });
            }}
          />
          <Spacer y={20} />
          <Grid>
            <Grid.Row>
              <Grid.Column width={3}>
                <SPClusterLinkingWorkloadNameContainer disabled={shouldFormBeDisabled} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </>
      </PaddedAndRaisedSegment>
    </>
  );
};
